export const CATEGORY = {
    discipline: ['Behavioral Sciences', 'Biochemistry', 'Biostatistics',
     'Cell Biology', 'Embryology', 'Genetics', 'Gross Anatomy', 'Histology', 'Immunology', 'Microbiology',
    'Molecular Biology', 'Pathology', 'Pathophysiology','Pharm/Therapeutics','Physiology','Social Science'],
    organSystem: ['Cardiovascular', 'Endocrine', 'Gastrointestinal', 'General Principles', 
    'Heme/Lymph', 'Multisystem', 'Musculoskeletal', 'Nervous', 'Renal/Urinary', 'Reproductive','Respiratory','Skin/Connective Tissue'],
    examType: ['Step 1','Step 2', 'Step 3', 'MCAT', 'COMLEX', 'OMM', 'ABSITE', 'ABR Core','ABIM', 'ABFM']
};

// Legacy stored values that must still read as a current CATEGORY entry.
// 'COMPLEX' was a typo for COMLEX that this picklist wrote until the fix; QLearn
// only recognises 'COMLEX', so existing rows are being retagged. Until every
// stored 'COMPLEX' is gone, opening such a question must show COMLEX as selected
// (and save it back as COMLEX) instead of silently dropping the exam type.
export const LEGACY_CATEGORY_ALIASES = {
    examType: { 'COMPLEX': 'COMLEX' }
};

export function normalizeCategoryName(type: string, name: string): string {
    const aliases = LEGACY_CATEGORY_ALIASES[type];
    return aliases && aliases.hasOwnProperty(name) ? aliases[name] : name;
}
